export default function TpMufRules({ show, onClose }) {
    if (!show) return null;

    return (
        <>
            <style>
                {`
                    .modal-header {
                        background-color: #fff;
                        color: #000;
                        padding: 1rem;
                        display: flex;
                        align-items: center;
                        max-width: 100%;
                        width: 100%
                    }
                    .modal-content {
                        max-width: 810px;
                        max-height: 100vh;
                        margin-top: 25px;
                        background-color: #fff;
                        color: #000;
                        border-radius: 8px;
                        margin-left: auto; 
                        margin-right: auto; 
 
                    }
                    .imgt20 {
                        max-width: 100%;  
                        height: auto;     
                        display: block;
                    }
                `}
            </style>
            <div class="modal fade show" id="modalMarketRules" tabindex="-1" role="dialog" aria-labelledby="modalMarketRules" style={{ display: "block", paddingLeft: "0px" }}>
                <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Market Rules</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close" onClick={onClose}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div id="market-rules-text" class="modal-body">
                            <div>

                                <div>
                                    <center>
                                        <h1><b>MUFLIS TEENPATTI</b></h1>
                                        <h2>Rules and Regulations</h2>
                                        <hr></hr>
                                        <div>
                                            <h3><b>GAME OBJECTIVES</b></h3>
                                            <p class="pt20">This game is opposite of Teen Patti. To guess whether the Player A or Player B will get a lower hand as opposed to High hand in Teen Patti. </p>
                                        </div>
                                        <div>
                                            <h3><b>Main Market RULES</b></h3>
                                            <p class="pt20">Hands dealt: 2 (3 cards for Player A, 3 cards for Player B)</p>
                                            <p class="pt20">Bets: Lowest hand wins.</p>
                                            <p class="pt20">High Card market payouts:</p>
                                            <p class="pt20">Hand Dealt must not have, Pair, Flush, Straight, Straight Flush or Trio and the User bets on High Card market, Payouts are defined as below for the runner the bets are placed.</p>
                                            <div>
                                                <center><h3><b>PLUS Market Rules</b></h3></center>
                                                <div>
                                                    <p class="pt20"> Bet stands on the individual player, Independent of other player's hands. If the same player holds any of the below hand would yield the following payout, else customer loses the bet. </p>
                                                    <table class="table table-bordered table-sm">
                                                        <thead>
                                                            <tr>
                                                                <th>Hands</th>
                                                                <th>Payout</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <th>With highest card of 9</th>
                                                                <th>1:2</th>
                                                            </tr>
                                                            <tr>
                                                                <th>With highest card of 8	</th>
                                                                <th>1:3</th>
                                                            </tr>
                                                            <tr>
                                                                <th>With highest card of 7	</th>
                                                                <th>1:4</th>
                                                            </tr>
                                                            <tr>
                                                                <th>With highest card of 6	</th>
                                                                <th>1:7</th>
                                                            </tr>
                                                            <tr>
                                                                <th>With highest card of 5	</th>
                                                                <th>1:23</th>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                    <p class="pt20">Suit Ranking (Highest to Lowest): Spades, Hearts, Clubs, Diamonds</p>
                                                    <p class="pt20">Card Ranking are opposite to that of Teen Patti.</p>
                                                    <p class="pt20">(Refer to the card rankings in Teen Patti rules page)</p>
                                                </div>
                                            </div>
                                        </div>
                                    </center>
                                </div>

                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}